let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("24YXm"), load("c26fA"), load("2iVxb")]).then(() => parcelRequire('kf8Fl'));